import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { useDeleteNoticeById } from "../../../../../api/inquiries/notice/use-notice";
import { useNoticeById } from "../../../../../api/inquiries/notice/use-notice-detail";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";
import EditorViewer from "../../../../../components/EditorViewer";

const NoticeDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useNoticeById(id);
  const { mutate: deleteNoticeById } = useDeleteNoticeById();
  const noticeData = data?.data;

  const handleBack = () => {
    navigate("/bulletin-board");
  };

  const handleEdit = () => {
    navigate("edit");
  };

  const onDeleteNotice = async () => {
    await deleteNoticeById(id);
  };

  return (
    <>
      <div>
        <TitlePage title="공지사항 > 공지사항 상세" />
        <div className="mt-4">
          <FieldBox label="제목">
            <span className="p-2 text-black">{noticeData?.title}</span>
          </FieldBox>
          <div className="flex items-center">
            <div className="w-1/2">
              <FieldBox splitted label="등록일시">
                <span className="p-2">
                  {dayjs(noticeData?.createdAt).format("YYYY-MM-DD HH:mm")}
                </span>
              </FieldBox>
            </div>
            <div className="w-1/2">
              <FieldBox splitted label="조회수">
                <span className="p-2">{noticeData?.hitLog ?? 0}</span>
              </FieldBox>
            </div>
          </div>
          <FieldBox isLast label="내용">
            <EditorViewer
              delta={JSON.parse(noticeData?.contents)}
              className="min-h-[300px] overflow-auto"
            />
          </FieldBox>
          <div className="flex justify-end mt-4">
            <Button width="w-24" onClick={handleBack} text="목록" />
            <Modal
              description={
                <span>
                  해당 항목을 삭제하시겠습니까?
                  <br />
                  삭제할 경우 데이터 복구가 불가능합니다.
                </span>
              }
              onSubmit={onDeleteNotice}
            >
              <Button width="w-24" text="삭제" />
            </Modal>
            <Modal description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다.">
              <Button width="w-24" onClick={handleEdit} primary text="수정" />
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoticeDetailPage;
